import styled from 'styled-components';

import { getThemeColor } from '@utils/styled';

import { IconButton } from '@common/components/IconButton';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 6rem;
`;

export const PaginationButton = styled(IconButton)`
  width: 4rem;
  height: 4rem;

  &:disabled {
    box-shadow: none;
    background-color: ${getThemeColor('bluegrey.95')};
    color: ${getThemeColor('bluegrey.80')};
    fill: ${getThemeColor('bluegrey.80')};
  }

  svg {
    width: 12px;
    height: 20px;
  }
`;

export const PageInput = styled.input`
  width: 6rem;
  margin-left: 1rem;
  border: 1px solid ${getThemeColor('bluegrey.70')};
  border-radius: 1rem;
  padding: 0 1.5rem;
  font-size: 1.6rem;
  line-height: 2.8rem;
  appearance: textfield;
  text-align: center;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
`;

export const TotalPages = styled.span`
  padding: 0 0.9rem;
`;

export const HiddenSubmit = styled.button`
  position: absolute;
  z-index: -1;
  visibility: hidden;
`;
